/*
 * @Author: YuanYuan
 * @Date: 2025-07-18 17:22:21
 * @LastEditTime: 2026-02-11 15:20:24
 * @Description: 全局统一的表格列
 */
import i18n from '@/i18n'
import { sthFromLang } from '@/utils/base'

export default [
  // 订单号
  {
    name: 'OrderNoCol',
    value: () => ({
      label: i18n.t('orders.orderNumber'),
      width: 165
    })
  },
  // 计费模式
  {
    name: 'BillModeCol',
    value: () => ({
      label: i18n.t('orders.billMode'),
      align: 'center',
      width: sthFromLang(90, 120)
    })
  },
  // 原价
  {
    name: 'OriginPriceCol',
    value: () => ({
      label: i18n.t('orders.originPrice'),
      align: 'right'
    })
  },
  // 总计
  {
    name: 'TotalPriceCol',
    value: () => ({
      label: i18n.t('orders.sum'),
      align: 'right'
    })
  },
  // 优惠
  {
    name: 'PreferentialCol',
    value: () => ({
      label: i18n.t('orders.preferential'),
      align: 'right'
    })
  },
  // 单价
  {
    name: 'UnitPriceCol',
    value: () => ({
      label: i18n.t('orders.unitPrice'),
      align: 'right'
    })
  },
  // 退款金额
  {
    name: 'RefundCol',
    value: () => ({
      label: i18n.t('orders.refundAmount'),
      align: 'right'
    })
  },
  // 已消费金额
  {
    name: 'SpentCol',
    value: () => ({
      label: i18n.t('orders.spentAmount'),
      align: 'right'
    })
  },
  // 订单金额
  {
    name: 'OrderCostCol',
    value: () => ({
      label: i18n.t('orders.orderCost'),
      align: 'right'
    })
  },
  // 状态
  {
    name: 'StatusCol',
    value: () => ({
      label: i18n.t('common.status'),
      align: 'right'
    })
  },
  // 支付方式
  {
    name: 'PayMethodCol',
    value: () => ({
      label: i18n.t('orders.payMethod'),
      align: 'right'
    })
  }
]
